import { render, staticRenderFns } from "./_idorder.vue?vue&type=template&id=10dab7c1&"
import script from "./_idorder.vue?vue&type=script&lang=js&"
export * from "./_idorder.vue?vue&type=script&lang=js&"
import style0 from "./_idorder.vue?vue&type=style&index=0&id=10dab7c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports